/** Short human-readable label from a browser User-Agent (no external deps). */
export function summarizeUserAgent(ua?: string | null): string {
  if (!ua || !ua.trim()) return '—'
  const u = ua.toLowerCase()
  let os = ''
  if (u.includes('iphone')) os = 'iPhone'
  else if (u.includes('ipad')) os = 'iPad'
  else if (u.includes('android')) os = 'Android'
  else if (u.includes('mac os') || u.includes('macintosh')) os = 'macOS'
  else if (u.includes('windows')) os = 'Windows'
  else if (u.includes('linux')) os = 'Linux'

  let browser = ''
  if (u.includes('edg/')) browser = 'Edge'
  else if (u.includes('opr/') || u.includes('opera')) browser = 'Opera'
  else if (u.includes('chrome') && !u.includes('edg')) browser = 'Chrome'
  else if (u.includes('safari') && !u.includes('chrome')) browser = 'Safari'
  else if (u.includes('firefox')) browser = 'Firefox'
  else browser = 'Navigateur'

  if (os) return `${browser} · ${os}`
  return browser
}
